import KunLoading85 from './src/index'

KunLoading85.install = function (Vue) {
	Vue.component(KunLoading85.name, KunLoading85);
}

export default KunLoading85;
